import { theme } from '@features/executive-report/domain/theme';
import { TableCell, TableOptions, TableRow } from '@features/powerpoint';

export const ROWS_PER_TABLE = 10;

export const defaultTableOptions = {
  fontSize: 10,
  color: theme.colors.white,
  valign: 'middle',
  h: 4.76,
  w: 2.72,
  x: 0.5,
  y: 1.51,
} as const satisfies TableOptions;

export const INDEX_WIDTH = 0.4;
export const NORMAL_WIDTH = INDEX_WIDTH * 3.15;
export const STATE_WIDTH = INDEX_WIDTH * 1.8;
export const VISIT_INDEX_WIDTH = INDEX_WIDTH * 2.7;
const HEADER_ROW_FILL_COLOR = '#44546A';

const blackBorder = {
  color: theme.colors.black,
  pt: 1,
} as const satisfies NonNullable<TableCell['options']>['border'];

const noBorder = { type: 'none' } as const satisfies NonNullable<
  TableCell['options']
>['border'];

const fillByIndex = (
  index: number
): NonNullable<TableCell['options']>['fill'] =>
  index % 2 === 0
    ? {
        color: theme.colors.black,
        transparency: 80,
      }
    : undefined;

const bordersByIndex = (
  index: number,
  totalRows: number = ROWS_PER_TABLE
): NonNullable<TableCell['options']>['border'] =>
  index === totalRows - 1
    ? [noBorder, noBorder, blackBorder, noBorder]
    : undefined;

export const cellOptionsByIndex = (
  index: number,
  totalRows?: number
): NonNullable<TableCell['options']> => ({
  fill: fillByIndex(index),
  border: bordersByIndex(index, totalRows),
});

export const headersToTableRow = (
  headers: string[],
  options?: TableCell['options']
): TableRow =>
  headers.map(
    (header, index): TableCell => ({
      text: header.toUpperCase(),
      options: {
        bold: true,
        color: theme.colors.inmarketGreen,
        align: index === headers.length - 1 ? 'center' : 'left',
        border: [
          {
            color: theme.colors.black,
            pt: 1,
          },
          { type: 'none' },
          {
            color: theme.colors.black,
            pt: 1,
          },
          { type: 'none' },
        ],
        fill: {
          color: HEADER_ROW_FILL_COLOR,
          transparency: 72,
        },
        ...options,
      },
    })
  );
